import React, { useMemo } from "react";
import Tooltip from "components/Tooltip";
import { IoMdOpen } from "@hacknug/react-icons/io";
import Analytics, { CLICK_EXTERNAL_LINK } from "utils/analytics";
import { COLORS } from "utils/styles";
import { v4 as uuidv4 } from "uuid";
import { TOOLTIP_POSITION } from "utils/constants/ui";

const DEFAULT_CLASSES = {
  container: "",
  link:
    "link flex flex-row items-center justify-center link__decoration--hover color-primary pointer",
  copy: "f7 pr1 fw5"
};

const DEFAULT_COPY = "View on Stripe";

const ExternalLink = ({
  href,
  copy,
  customClasses,
  color = COLORS.blue,
  size = 16,
  tooltip,
  position = TOOLTIP_POSITION.TOP,
  disabled,
  hideCopy,
  hideIcon
}) => {
  const tooltipId = useMemo(() => uuidv4(), []);
  if (!href) {
    throw new Error("External link requires destination");
  }
  const classes = { ...DEFAULT_CLASSES, ...customClasses };

  const containerProps = {
    className: classes.container
  };
  if (!disabled) {
    containerProps.onClick = () => {
      Analytics.track(CLICK_EXTERNAL_LINK, {
        copy,
        href
      });
    };
  }

  const linkProps = {
    className: classes.link
  };
  if (!disabled) {
    linkProps.target = "_blank";
    linkProps.href = href;
  }
  const copyVal = copy || DEFAULT_COPY;
  return (
    <Tooltip id={tooltipId} tooltip={tooltip} position={position}>
      <div {...containerProps}>
        <a {...linkProps}>
          {!hideCopy && copyVal && copyVal.trim() && (
            <div className={classes.copy}>{copyVal}</div>
          )}
          {!hideIcon && (
            <div className="flex flex-shrink-0">
              <IoMdOpen color={color} size={size} />
            </div>
          )}
        </a>
      </div>
    </Tooltip>
  );
};

export default ExternalLink;
